import React, {Component} from 'react';
import { DragSource } from 'react-dnd';

const itemSource = {
    beginDrag(props) {
        console.log('dragging')
        return props.item
    },
    endDrag(props,monitor,component) {
        if (!monitor.didDrop()) {
            return
        }
        const item = props.item
        return props.handleDrop(item,props.index)
    }
}

function collect(connect,monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    }
}

class PaperConfigItems extends Component {
    render() {
        const {connectDragSource,item} = this.props
        return connectDragSource(
            <div>
                <span>{item.field}:&nbsp;{item.title}</span>
            </div>    
        )
    }
}
export default DragSource('box', itemSource, collect)(PaperConfigItems);


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/PaperConfigItems.js